import React, { ReactElement } from "react";

import { LoginMainTitle } from "@/components/atoms/typograhies/LoginMainTitle";
import { LayoutLoginTemplate } from "@/components/templates/layout/Login";

const styles = {
  wrapper: "p-2 bg-theme-thin rounded-2xl md:p-4",
  inner:
    "py-4 px-2 space-y-6 md:space-y-10 bg-white rounded-2xl md:py-6 md:px-[13.75%]",
  section: "space-y-2",
  header: "font-bold",
};

export default function PrivacyIndex() {
  return (
    <article className="mx-auto max-w-[992px] md:pt-14">
      <LoginMainTitle
        title="プライバシーポリシー"
        className="mb-11 text-center md:mb-6"
      />
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          <section>
            <p>
              オーガニックスタイル株式会社（以下「当社」といいます。）は、Yoyacooサービスにおける、Yoyacooユーザー等の当社の直接的な顧客のほか、当該Yoyacooユーザーの顧客（以下「お客様」といいます。）の個人情報の保護についてこれを重要なものことを深く認識し、個人情報の保護に関する法律（以下「個人情報保護法」といいます。）の定める個人情報を、以下のプライバシーポリシー（以下「本ポリシー」といいます。）に従って、適切に取得し、適切な取り扱い及び保護に努めるものといたします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１条 個人情報</h2>
            <p>
              「個人情報」とは、個人情報保護法第2条第１項にいう「個人情報」を意味するものとし、生存する個人に関する情報であって、当該情報に含まれる氏名、生年月日、住所、電話番号、連絡先その他の記述等により特定の個人を識別できる情報及び容貌、指紋、声紋にかかるデータ、及び健康保険証の保険者番号などの当該情報単体から特定の個人を識別できる情報（個人識別情報）をいいます。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第２条 個人情報の収集方法</h2>
            <p>
              当社は、お客様が利用登録をされる際、氏名、生年月日、住所、電話番号、メールアドレス、銀行口座情報等、第3条に定める利用目的に必要な個人情報を、当社提供サービスのご登録やご利用、当社への問い合わせやご要望、メールマガジン等へのお申込み、アンケートへの回答などを通じて収集することがあります。また、お客様と当社提携先などとの間でなされたお客様の個人情報を含む取引記録や決済に関する情報を、当社の提携先などから収集することがあります。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第３条 個人情報の利用目的</h2>
            <p>
              当社が個人情報を利用する目的は、以下の通りです。
              <br />
              &nbsp;・当社のYoyacooサービスの運営、提供及び顧客管理を行うため（Yoyacooユーザーの顧客管理を含みます。）
              <br />
              &nbsp;・Yoyacooサービスに関するお問い合わせに対応するため（本人確認を行うことを含みます。）
              <br />
              &nbsp;・お客様が利用中のYoyacooサービスの新機能、更新情報、キャンペーン等並びに当社が提供する他のサービスのご案内を送付するため（当社からのメールマガジン配信に同意していただきます。）
              <br />
              &nbsp;・メンテナンス、重要なお知らせなど必要なご連絡のため
              <br />
              &nbsp;・利用規約に違反したお客様や、不正・不当な目的でYoyacooサービスを利用しようとするお客様の特定をしてご利用をお断りするため
              <br />
              &nbsp;・お客様にご自身の登録情報の閲覧や変更、削除、ご利用状況の閲覧を行っていただくため
              <br />
              &nbsp;・利用規約その他Yoyacooサービスに関する変更のご案内のため
              <br />
              &nbsp;・Yoyacooサービスに関連して個人を識別できない形式に書こうした統計データ作成のため
              <br />
              &nbsp;・その他Yoyacooサービスの提供に必要と認められる目的のため
              <br />
              &nbsp;・上記の利用目的に付随する目的のため
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第４条 利用目的の変更</h2>
            <p>
              当社は、利用目的が変更前と関連性を有すると合理的に認められる場合には、個人情報の利用目的を変更するものとします。かかる利用目的の変更を行った場合は、変更後の目的について、当社所定の方法により、お客様に通知し、またはYoyacooのウェブサイト上に公表するものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第５条 個人情報の管理</h2>
            <p>
              1.当社は、個人データの紛失、毀損又は漏洩の防止等、その管理のために必要かつ適切な安全管理措置を講じ、そのための迅速な是正措置を講じる体制を築き維持するものとします。また。当社は、発見された違反や予期せぬ事故に対し、速やかにこれを是正し、予防措置を実施します。具体的には次の通りです。
              <br />
              &nbsp;1） 組織的安全管理措置
              <br />
              &nbsp;個人情報等の漏えい、滅失または毀損の防止のために管理責任者を選定し、規程を定め、必要かつ適切な組織的安全管理措置を講じています。個人情報の取扱状況について定期的に自己点検を実施し、責任者が確認した結果を踏まえ、必要に応じてルールの見直し、個人情報取扱者への指導を行っています。
              <br />
              &nbsp;2） 人的安全管理措置
              <br />
              &nbsp;個人情報の取扱いに関する留意事項について、個人情報取扱者に定期的な研修等を行っています。
              <br />
              &nbsp;3） 物理的安全管理措置
              <br />
              &nbsp;個人情報を取り扱う書類は施錠保管し、個人情報を取り扱う機器の盗難又は紛失等を防止するため適切な盗難防止対策を講じています。また、電子媒体や書類等の取得、移動、廃棄に際して、パスワードによる保護等、必要かつ適切な安全対策を講じています。
              <br />
              &nbsp;4） 技術的安全管理措置
              <br />
              &nbsp;個人情報等を取り扱う機器、サーバー等へのアクセス担当者を限定するとともに、不正なアクセスを遮断する対策を講じています。
            </p>
            <p>
              ２.当社は、個人データを取り扱う従業者又は委託した協力業者に対しても、必要かつ適切な監督を行うものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第６条 個人情報の第三者提供</h2>
            <p>
              1.当社は、次に掲げる場合を除いて、あらかじめお客様の同意を得ることなく、第三者に個人情報を提供することはありません。ただし、個人情報保護法その他の法令で認められる場合を除きます。
              <br />
              &nbsp;・人の生命、身体または財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき
              <br />
              &nbsp;・公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき
              <br />
              &nbsp;・国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
              <br />
              &nbsp;・予め次の事項を告知あるいは公表し、かつ当社が個人情報保護委員会に届出をしたとき
              <br />
              &nbsp;・利用目的に第三者への提供を含むこと
              <br />
              &nbsp;・第三者に提供されるデータの項目
              <br />
              &nbsp;・第三者への提供の手段または方法
              <br />
              &nbsp;・本人の求めに応じて個人情報の第三者への提供を停止すること
              <br />
              &nbsp;・本人の求めを受け付ける方法
            </p>
            <p>
              2.前項の定めにかかわらず、次に掲げる場合には、当該情報の提供先は第三者に該当しないものとします。
              <br />
              &nbsp;・当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部または一部を第三者に委託する場合
              <br />
              &nbsp;・合併その他の事由による事業の承継に伴って個人情報が提供される場合
              <br />
              &nbsp;・個人情報を特定の者との間で共同して利用する場合であって、その旨並びに共同して利用される個人情報の項目、共同して利用する者の範囲、利用する者の利用目的および当該個人情報の管理について責任を有する者の氏名または名称について、あらかじめ本人に通知し、または本人が容易に知り得る状態にする場合
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第７条 個人情報の開示</h2>
            <p>
              1.当社は、本人から個人情報の開示を求められたときは、本人に対し、遅滞なくこれを開示するものとします。ただし、開示することにより次のいずれかに該当する場合は、その全部または一部を開示しないこともあり、開示しない決定をした場合には、その旨を遅滞なく通知します。なお、個人情報の開示に際しては、1件あたり800円の手数料を申し受けます。
              <br />
              &nbsp;・本人または第三者の生命、身体、財産その他の権利利益を害するおそれがある場合
              <br />
              &nbsp;・当社の業務の適正な実施に著しい支障を及ぼすおそれがある場合
              <br />
              &nbsp;・その他法令に違反することとなる場合
            </p>
            <p>
              2.前項の定めにかかわらず、履歴情報および特性情報などの個人情報以外の情報については、原則としてこれを開示しないものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第８条 個人情報の訂正・追加・削除</h2>
            <p>
              1.お客様は、当社サービスの利用開始時に登録した個人情報を変更する場合は、Yoyacooサービスページより変更することができます。
              <br />
              2.当社の保有する自己の個人情報が誤ったものであり、自ら変更できない場合、当社が定める手続きにより、当社に対して個人情報の訂正、追加または削除（以下、「訂正等」といいます。）を請求することができます。
              <br />
              3.当社は、お客様から前項の請求を受けて、ご本人確認をした上で、当該お客様の請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の訂正等を行うものとします。
              <br />
              4.当社は、前項の規定に基づいて訂正等を行った場合、または訂正等を行わない旨の決定をしたときは、遅滞なくお客様にその旨を通知するものとします。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第９条 個人情報の利用停止等</h2>
            <p>
              1.当社は、本人から、個人情報が、利用目的の範囲を超えて取り扱われているという理由、または不正の手段により取得されたものであるという理由によって、その利用の停止または消去（以下、「利用停止等」といいます。）を求められた場合には、遅滞なく必要な調査を行うものとします。
              <br />
              2.当社は、前項の調査結果に基づき、その請求に応じる必要があると判断した場合には、遅滞なく、当該個人情報の利用停止等を行うものとします。
              <br />
              3.当社は、前項の規定に基づき利用停止等を行った場合、または利用停止等を行わない旨の決定をしたときは、遅滞なく、これをお客様に通知します。
              <br />
              4.前２項にかかわらず、利用停止等に多額の費用を有する場合その他利用停止等を行うことが困難な場合であって、お客様の権利利益を保護するために必要なこれに代わるべき措置をとれる場合は、この代替策を講じるものとします
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１０条 Cookie等の技術について</h2>
            <p>
              1.当社は、サービスレベルの向上を目的に、Cookie及び類似の技術を利用する場合があります。これらの技術は、当社サービスの利用状況等の把握、ナビゲーションの強化等お客様へのサービスの向上を目的として利用いたします。この場合、Cookieは、ご使用のウェブブラウザの設定によって無効にすることができます。しかしながら、その無効化によって、当社サービスの一部を正常に利用できなくなる場合がございますので、その点予めご了承くださいませ。
              <br />
              2.当社は、支払処理、分析、その他Yoyacooサービスにストライプジャパン株式会社が提供するサービス（以下「Stripe」といいます。）を使用しております。Stripeは、そのサービスに接続するデバイスの識別情報を収集します。Stripeは、その情報を使用して、サービスを運営および向上させておりますが、これには不正使用検出サービスも含まれます。Stripeやそのプライバシーポリシーの詳細については、
              <a href="https://stripe.com/privacy">
                https://stripe.com/privacy
              </a>
              」をご確認ください。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>
              第１１条 プライバシーポリシーの変更
            </h2>
            <p>
              1.本ポリシーの内容は、法令その他本ポリシーに別段の定めのある事項を除いて、お客様に通知することなく、変更する場合があります。
              <br />
              2.当社が別途定める場合を除いて、変更後のプライバシーポリシーは、本ウェブサイトに掲載したときから効力を生じるものとし、お客様は当該変更に同意したものとみなされます。
            </p>
          </section>
          <section className={styles.section}>
            <h2 className={styles.header}>第１２条 お問い合わせ窓口</h2>
            <p>
              本ポリシーに関するお問い合わせは、下記の窓口までお願いいたします。
            </p>
            <p>
              〒167-0053
              <br />
              東京都杉並区西荻南2-24-7
              <br />
              オーガニックスタイル株式会社
              <br />
              代表取締役：渡辺隆
              <br />
              E-mail：Yoyacoo489@gmail.com
            </p>
          </section>
        </div>
      </div>
    </article>
  );
}

PrivacyIndex.getLayout = function getLayout(page: ReactElement) {
  return <LayoutLoginTemplate isTextLeft={true}>{page}</LayoutLoginTemplate>;
};
